import type { ClientPlugin } from 'fets';

export function AuthPlugin(provideFunc: () => Promise<string>): ClientPlugin {
  const getToken = async () => await provideFunc();

  return {
    async onRequestInit({ requestInit }) {
      const token = await getToken();
      requestInit.headers = {
        ...requestInit.headers,
        Authorization: `Bearer ${token}`,
      };
    },
  };
}
